var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcMembershipStandard16X8 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 8,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.405 0H9.614c-.887 0-1.61.723-1.61 1.61v4.773c0 .886.723 1.61 1.61 1.61h4.776c.887 0 1.61-.724 1.61-1.61V1.602c0-.879-.716-1.594-1.602-1.594",
  fill: "#21AB73"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.402.008H1.61C.723.008 0 .73 0 1.618V6.39C0 7.277.723 8 1.61 8h4.784c.887 0 1.61-.723 1.61-1.61V1.61A1.6 1.6 0 0 0 6.402.007Z",
  fill: "#192D82"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M2.318 6.336a.521.521 0 1 1-1.042 0 .521.521 0 0 1 1.042 0Z",
  fill: "#2E80FF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.686 4.51a.571.571 0 0 0-.428.225c-.272.31-.63.56-1.104.56a1.301 1.301 0 0 1-1.307-1.291c0-.692.56-1.29 1.307-1.29.474 0 .832.24 1.104.559.086.109.257.225.428.225.311 0 .529-.233.529-.49a.545.545 0 0 0-.086-.303A2.33 2.33 0 0 0 4.161 1.68c-1.33 0-2.364 1.019-2.364 2.333 0 1.313 1.034 2.332 2.364 2.332.856 0 1.54-.397 1.968-1.019a.553.553 0 0 0 .086-.31c0-.257-.218-.49-.529-.49",
  fill: "#fff"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M2.318 6.336a.521.521 0 1 1-1.042 0 .521.521 0 0 1 1.042 0Z",
  fill: "#2E80FF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M12.002 1.664a.521.521 0 0 0-.522.52v3.608a.521.521 0 0 0 1.043 0V2.184a.521.521 0 0 0-.521-.52Z",
  fill: "#fff"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M14.335 3.988a.521.521 0 0 0-.521-.52h-3.617a.521.521 0 1 0 0 1.041h3.617a.521.521 0 0 0 .521-.52Z",
  fill: "#fff"
})));
export default SvgIcMembershipStandard16X8;